// extracted by mini-css-extract-plugin
export default {"volumeSection":"VolumeSection_volumeSection__sZqvU","phonetic":"VolumeSection_phonetic__agGgt","rank":"VolumeSection_rank__j8oTK"};